import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=7d6d85b0"
import script from "./ModelForm.vue?vue&type=script&lang=js"
export * from "./ModelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d6d85b0')) {
      api.createRecord('7d6d85b0', component.options)
    } else {
      api.reload('7d6d85b0', component.options)
    }
    module.hot.accept("./ModelForm.vue?vue&type=template&id=7d6d85b0", function () {
      api.rerender('7d6d85b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/process/ModelForm.vue"
export default component.exports